import Chart from "react-apexcharts";
import { reduzirNome } from "../../utils/reduzirNome";

export default function GraficoLine({ title, labels, values }) {

    const options = {
        chart: {
            type: "bar",
            toolbar: { show: false },
            scrollablePlotArea: {
                enabled: true,
                originX: 0,
                scrollY: false,
            },
        },
        xaxis: {
            categories: labels.map((item) => reduzirNome(item)),
            labels: {
                style: { fontSize: "12px" },
            },
        },
        dataLabels: {
            enabled: false,
        },
        yaxis: {
            floating: false,
            logarithmic: true, // escala logarítmica
            labels: {
                show: true,
                minWidth: 75,   // largura mínima reservada p/ os valores
                maxWidth: 75,   // largura máxima (fixa),
                formatter: (value) =>
                    Number(value).toLocaleString("pt-BR", {
                        style: "currency",
                        currency: "BRL",
                    }),
            },
        },
        tooltip: {
            y: {
                formatter: (value) =>
                    Number(value).toLocaleString("pt-BR", {
                        style: "currency",
                        currency: "BRL",
                    }),
            },
            x: {
                formatter: (_, opts) => {
                    const index = opts.dataPointIndex;
                    return labels[index]; // mostra nome completo
                },
            },
        },
        plotOptions: {
            bar: {
                borderRadius: 6,
                columnWidth: "60%",
            },
        },
        colors: ["#e74a23ff"],
        legend: {
            position: "top",
            labels: { colors: "#333" },
            fontSize: "12px",
        },
        responsive: [
            {
                breakpoint: 768,
                options: {
                    plotOptions: { bar: { columnWidth: "80%" } },
                    xaxis: { labels: { rotate: -45 } },
                },
            },
        ],
    };

    const series = [
        {
            name: "Valor (R$)",
            data: values,
        },
    ]

    return (
        <div className="bg-white p-4 rounded-2xl shadow-md fade-in">
            <h2 className="text-xl font-bold mb-2">{title}</h2>
            <div className="w-full">
                {values.length > 0 ?
                    <Chart options={options} series={series} type="line" height={320} />
                    :
                    "Não existem dados disponíveis para o intervalo selecionado."
                }
            </div>
        </div>
    );
}